import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import { FormattedNumber } from 'react-intl';

import Icon from '../../../../../../components/Icon';
import Button from '../../../../../../components/Button';
import NfTable from '../NfTable';

// styles
import './styles.css';

class SelectionComponent extends Component {
  constructor() {
    super();
    this.state = { details: false };
  }

  _toogleComponent = () => this.setState({ details: !this.state.details });

  _calcVolume = () =>
    this.props.nfSelecteds.reduce(
      (prevValue, value) => value.volume + prevValue,
      0,
    );

  _calcWeight = () =>
    this.props.nfSelecteds.reduce(
      (prevValue, value) => value.weight + prevValue,
      0,
    );

  _calcValue = () =>
    this.props.nfSelecteds.reduce(
      (prevValue, value) => value.value + prevValue,
      0,
    );

  _renderBar = nfSelecteds => (
    <div
      className={`SelectionComponent__bar ${
        this.state.details
          ? 'SelectionComponent__bar--top'
          : 'SelectionComponent__bar--bottom'
      }`}
    >
      <div className="SelectionComponent__wrapper">
        <Icon
          name={`${this.state.details ? 'arrow_drop_down' : 'arrow_drop_up'}`}
          onClick={this._toogleComponent}
          className="SelectionComponent__icon"
        />
        <div className="SelectionComponent__nf-count">{nfSelecteds.length}</div>
        NFs adicionadas
      </div>
      <div className="SelectionComponent__wrapper">
        <div className="SelectionComponent__total-columns">
          <span>Total Volumes</span>
          <span>
            <b>{this._calcVolume()}</b>
          </span>
        </div>
        <div className="SelectionComponent__total-columns">
          <span>Peso Total</span>
          <span>
            <strong>
              <FormattedNumber
                value={this._calcWeight()}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />{' '}
              kg
            </strong>
          </span>
        </div>
        <div className="SelectionComponent__total-columns">
          <span>Valor Total</span>
          <span>
            <strong>
              <FormattedNumber
                value={this._calcValue()}
                // -disable-next-line react/style-prop-object
                style="currency"
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                currency="BRL"
                currencyDisplay="symbol"
              />
            </strong>
          </span>
        </div>
        <Button
          text="Prosseguir"
          skin="secondary"
          className="SelectionComponent__button"
          onClick={this.props.nextStep}
        />
      </div>
    </div>
  );

  render() {
    const { selectNf, nfSelecteds } = this.props;
    return (
      <div className="SelectionComponent">
        {this.state.details && (
          <CSSTransition
            classNames="SelectionComponent"
            in
            appear
            timeout={200}
          >
            <div
              className="SelectionComponent__overlay"
              onClick={this._toogleComponent}
            >
              <div
                className="SelectionComponent__content"
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {this._renderBar(nfSelecteds)}
                <div className="SelectionComponent__nf-table">
                  <NfTable
                    getLabelById={this.props.getLabelById}
                    data={nfSelecteds}
                    selectNf={selectNf}
                    nfSelecteds={nfSelecteds}
                  />
                </div>
              </div>
            </div>
          </CSSTransition>
        )}

        {!this.state.details &&
          nfSelecteds.length > 0 &&
          this._renderBar(nfSelecteds)}
      </div>
    );
  }
}

export default SelectionComponent;
